import { ModelRow } from "@mcleod/core";
import {
    BlurEvent, DataSourceMode, Table, TableRow, TableRowCreationEvent, TableRowDisplayEvent, Textbox
} from "@mcleod/components";
import { AutogenLayoutOffice401kRateDetails } from "./autogen/AutogenLayoutOffice401kRateDetails";

export class Office401kRateDetails extends AutogenLayoutOffice401kRateDetails {
    private _rateRow: ModelRow;

    onLoad() {
        this.table401kDetails.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            if (this.rateRow) {
                this.setFieldVisibility(tableRow, this.rateRow.get("calculation_method"));
            }
        });
    }

    initialize(rateRow: ModelRow, data: ModelRow[]) {
        this.rateRow = rateRow;
        this.table401kDetails.dataSource.setRowsAndMode(DataSourceMode.UPDATE, data);
    }

    set rateRow(data: ModelRow) {
        if (data.compareWithData(this._rateRow)) {
            this._rateRow = data;
        }
    }

    get rateRow(): ModelRow {
        return this._rateRow;
    }

    table401kDetailsOnRowCreate(event: TableRowCreationEvent) {
        this.onRowCreate(this.table401kDetails, event);
    }

    private onRowCreate(table: Table, event: TableRowCreationEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.data._appending && this.rateRow) {
            tableRow.data.set("payee_id", this.rateRow.get("unique_id"));
        }
    }

    setFieldVisibility(tableRow: TableRow, calcMethod: string) {
        const textboxPayeePercent = tableRow.findComponentById("textboxPayeePercent") as Textbox;
        const textboxPayeeAmount = tableRow.findComponentById("textboxPayeeAmount") as Textbox;
        const textboxMatchPercent = tableRow.findComponentById("textboxMatchPercent") as Textbox;
        const textboxMatchAmount = tableRow.findComponentById("textboxMatchAmount") as Textbox;
        if (textboxPayeePercent && textboxPayeeAmount && textboxMatchPercent && textboxMatchAmount) {
            const isFlat = calcMethod === "F";
            const isPercent = calcMethod === "P";
            textboxMatchAmount.visible = isFlat;
            textboxMatchPercent.visible = isPercent;
            textboxPayeeAmount.visible = isFlat;
            textboxPayeePercent.visible = isPercent;
        }
    }

    textboxMatchAmountOnBlur(event: BlurEvent) {
        const textbox = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(textbox);
        const modelRow = tableRow.data as ModelRow;
        if (!modelRow.isNull("match_amount")) {
            const matchAmount = modelRow.getCurrency("match_amount");
            matchAmount.setCurrencyCode("USD");
            modelRow.set("match_amount", matchAmount);
            textbox.displayComponentData(modelRow, null, tableRow.index);
        }
    }

    textboxPayeeAmountOnBlur(event: BlurEvent) {
        const textbox = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(textbox);
        const modelRow = tableRow.data as ModelRow;
        if (!modelRow.isNull("payee_amount")) {
            const matchAmount = modelRow.getCurrency("payee_amount");
            matchAmount.setCurrencyCode("USD");
            modelRow.set("payee_amount", matchAmount);
            textbox.displayComponentData(modelRow, null, tableRow.index);
        }
    }
}
